/* eslint-disable react/no-multi-comp */
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';
import { TableCell, DialogContentText, Grid } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import { Table, DropzoneModal, DialogDefault, SwitchComponent, Input, SearchSelect } from '../../components';
import NsmpModal from './NsmpModal';
import * as selectorsAuth from '../../store/auth/reducer';
import * as actionsNsmp from '../../store/nsmp/actions';
import * as Status from '../../constants/status';
import * as Role from '../../constants/role';
import Fuse from 'fuse.js';

const UsuMutuoServiceTab = ({
  nsmps,
  nsirId,
  updateNsmp,
  saveNsmp,
  cleanSelectedNsmp,
  nsirStatus,
  userRole,
  deleteNsmp,
  authData,
  userId,
  inspetorId,
  digitadorId,
  nsirTitle,
  cloneNsmp,
  deleteCloneNsmp,
}) => {
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const [openFotoInicial, setOpenFotoInicial] = useState(false);
  const [openFotoFinal, setOpenFotoFinal] = useState(false);
  const [openAnaliseRisco, setOpenAnaliseRisco] = useState(false);
  const [openClone, setOpenClone] = useState(false);
  const [openDeleteClone, setOpenDeleteClone] = useState(false);
  const [openFiltro, setOpenFiltro] = useState(false);
  const [cloneId, setCloneId] = useState(null);
  const [selectedId, setSelectedId] = useState(null);
  const [readOnly, setReadOnly] = useState(false);
  const [filtroValues, setFiltroValues] = useState({});
  const [titles] = useState(['Poste', 'Endereço', 'Coordenada', 'Situação do Poste', 'Status']);
  const [filterApplied, setFilterApplied] = useState(false);

  const isAdmin = () => authData && (authData.role === Role.ADMIN || authData.role === Role.SUPER_ADMIN);

  useEffect(() => {
    if (nsmps) {
      const sorted = [...nsmps].sort((a, b) => {
        const codeA = Number(a.codigo);
        const codeB = Number(b.codigo);

        if (!isNaN(codeA) && !isNaN(codeB)) {
          return codeA - codeB;
        }

        return String(a.codigo).localeCompare(String(b.codigo));
      })
      setRows(sorted)
    }
  }, [nsmps]);

  const onEdit = id => {
    setReadOnly(userRole === Role.DIGITADOR);
    cleanSelectedNsmp();
    setSelectedId(id);
    setOpen(true);
  };

  const onView = id => {
    setReadOnly(true);
    cleanSelectedNsmp();
    setSelectedId(id);
    setOpen(true);
  };

  const onAdd = () => {
    setReadOnly(false);
    cleanSelectedNsmp();
    setSelectedId(null);
    setOpen(true);
  };

  const handlerCancel = () => {
    setReadOnly(false);
    setOpen(false);
    setSelectedId(null);
  };

  const handlerConfirm = data => {
    setReadOnly(false);
    setOpen(false);
    setSelectedId(null);
    if (data && data.id) {
      updateNsmp({ ...data, nsirId });
    } else if (data) {
      saveNsmp({ ...data, nsirId });
    }
  };

  const isAnaliseRiscoOrFotoRegistro = nsmp => (nsmp.analiseRisco != null && nsmp.analiseRisco) || (nsmp.fotoRegistro != null && nsmp.fotoRegistro);
  const isService = nsmp => !isAnaliseRiscoOrFotoRegistro(nsmp);

  const getHeaderActions = () => {
    let actions = [{
      title: 'Filtro',
      onClick: () => setOpenFiltro(true)
    }];

    if (nsirStatus === Status.EM_INSPECAO && rows && rows.filter(row => isAnaliseRiscoOrFotoRegistro(row)).length === 0) {
      actions.push({
        title: 'Análise de Risco',
        onClick: () => setOpenAnaliseRisco(true)
      });
    }

    return actions;
  }

  const getStatusCell = row => {
    let status = "Aguardando Digitação";
    if (row.digitadoEmValue) {
      status = "Digitação Finalizada";
    } else if (row.subNsmpStatus && row.subNsmpStatus.total !== row.subNsmpStatus.aguardandoValidacao) {
      status = "Digitação em andamento";
    }
    
    return <TableCell>
      <>
        <span> {status} </span>
        {row.digitadoEmValue && <>  
          <br/>
          <span style={{ fontWeight: 'bold', fontSize: 12 }}> Digitado em: </span>
          <span style={{ fontSize: 12 }}> {row.digitadoEmValue} </span>
        </>}
        {row.subNsmpStatus && <>  
          <br/>
          <span style={{ fontWeight: 'bold', fontSize: 12 }}> Total: </span>
          <span style={{ fontSize: 12 }}> {row.subNsmpStatus.total} </span>
          <br/>
          <span style={{ fontWeight: 'bold', fontSize: 12 }}> Aguardando Validação: </span>
          <span style={{ fontSize: 12 }}> {row.subNsmpStatus.aguardandoValidacao} </span>
          <br/>
          <span style={{ fontWeight: 'bold', fontSize: 12 }}> Válidos: </span>
          <span style={{ fontSize: 12 }}> {row.subNsmpStatus.validado} </span>
          <br/>
          <span style={{ fontWeight: 'bold', fontSize: 12 }}> Inválidos: </span>
          <span style={{ fontSize: 12 }}> {row.subNsmpStatus.invalidado} </span>
        </>}
      </>
    </TableCell>
  }

  const renderRows = row => {
    if (isAnaliseRiscoOrFotoRegistro(row)) {
      return <>
        <TableCell>{row.analiseRisco? 'Análise de Risco' : 'Termo Responsabilidade Sucata'}</TableCell>
        <TableCell>-</TableCell>
        <TableCell>-</TableCell>
        <TableCell>-</TableCell>
        <TableCell>-</TableCell>
      </>
    }

    return <>
      <TableCell>ID {row.numeroPoste}</TableCell>
      <TableCell>{row.endereco}</TableCell>
      <TableCell style={{ fontSize: 12 }}>
        <>
          <span style={{ fontWeight: 'bold' }}> Latitude: </span>
          <span> {row.latitude} </span>
          <br/>
          <span style={{ fontWeight: 'bold' }}> Longitude: </span>
          <span> {row.longitude} </span>
        </>
      </TableCell>
      <TableCell>
        <>
          <span> {row.situacaoPoste} </span>
          {(row.situacaoPoste === "Não compartilhável" || row.situacaoPoste === "Sem irregularidade") && <>
            <br/>
            <span style={{ fontWeight: 'bold', fontSize: 12 }}> Obs.: </span>
            <span style={{ fontSize: 12 }}> {row.observacao} </span>
          </>}
        </>
      </TableCell>
      <TableCell>{getStatusCell(row)}</TableCell>
    </>
  };

  const onDelete = id => {
    deleteNsmp(id);
  };

  const toBase64 = file => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });

  const getFotos = async fotos => {
    const fotosList = [];

    for (let i in fotos) {
      fotosList.push({
        id: uuidv4(),
        nome: fotos[i].name,
        image: await toBase64(fotos[i])
      })
    }

    return fotosList;
  }

  const isInspetor = () => nsirStatus === Status.EM_INSPECAO && inspetorId === userId
  const isDigitador = () => nsirStatus === Status.EM_DIGITACAO && digitadorId === userId

  const fuse = new Fuse(rows, {
    keys: ['endereco'],
    threshold: 0.4,
    distance: 100, 
    ignoreLocation: true,
    includeScore: true,
    ignoreDiacritics: true,
    isCaseSensitive: false,
  });

  const filter = () => {
    let filteredRows = nsmps;

    if (Array.isArray(filtroValues.situacaoPostes)) {
      filteredRows = filteredRows.filter(p => {
        let situacaoPosteValue = p.situacaoPoste;
        if (!situacaoPosteValue) {
          situacaoPosteValue = "Vazio";
        }

        return filtroValues.situacaoPostes.includes(situacaoPosteValue);
      });
    }

    if (Array.isArray(filtroValues.statusDigitacao)) {
      filteredRows = filteredRows.filter(p => {
        const subNsmpStatus = p.subNsmpStatus;

        let statusDigitacaoRow = "1";
        if (p.digitadoEmValue) {
          statusDigitacaoRow = "3";
        } else if (subNsmpStatus && subNsmpStatus.total !== subNsmpStatus.aguardandoValidacao) {
          statusDigitacaoRow = "2";
        }

        return filtroValues.statusDigitacao.includes(statusDigitacaoRow)
      });
    }

    if (filtroValues.numeroPoste) {
      const termo = filtroValues.numeroPoste.toLowerCase();
      filteredRows = filteredRows.filter(p => p.numeroPoste && p.numeroPoste.toLowerCase().includes(termo));
    }

    if (filtroValues.endereco) {
      const fuzzyResults = fuse.search(filtroValues.endereco).map(r => r.item);
      const ids = new Set(fuzzyResults.map(p => p.id));
      filteredRows = filteredRows.filter(p => ids.has(p.id));
    }

    setRows(filteredRows);
  }

  return (
    <>
      <Table
        rows={rows}
        titles={titles}
        headerTitle={`Serviços > ${nsirTitle}`}
        showHeader={false}
        renderRows={renderRows}
        showEditRow={isService}
        hasRowActions
        onEdit={onEdit}
        onAdd={onAdd}
        onView={onView}
        onDelete={onDelete}
        showDelete={isInspetor()}
        showEdit={isInspetor() || isDigitador()}
        showView={isAdmin() ||
          (nsirStatus !== Status.EM_INSPECAO && nsirStatus !== Status.EM_DIGITACAO &&
            !(nsirStatus === Status.INSPECAO_FINALIZADA && authData.role === Role.DIGITADOR))
        }
        hasAdd={nsirStatus === Status.EM_INSPECAO}
        headerActions={getHeaderActions()}
        actions={
          [
            {
              key: 'delete',
              icon: <DeleteIcon />,
              show: (row) => row.idNsmpReference && nsirStatus === Status.EM_DIGITACAO,
              onClick: id => {
                setOpenDeleteClone(true);
                setCloneId(id);
              }
            },
          ]
        }
        widgetSubheader={filterApplied && Object.keys(filtroValues ?? {}).length > 0 ? <span style={{color: 'red'}}>*** Filtro aplicado</span> : null}
      />
      <NsmpModal
        open={open}
        onCancel={handlerCancel}
        onConfirm={handlerConfirm}
        selectedId={selectedId}
        readOnly={readOnly}
        nsirTitle={nsirTitle}
      />
      <DropzoneModal
        onClose={() => setOpenFotoInicial(false)}
        open={openFotoInicial}
        onSave={async fotos => {
          setOpenFotoInicial(false);
          handlerConfirm({
            fotos: await getFotos(fotos),
            codigo: '000',
            fotoInicio: true,
            fotoFim: false,
            analiseRisco: false,
            dataFotoDrone: moment().valueOf(),
          });
        }}
      />
      <DropzoneModal
        onClose={() => setOpenFotoFinal(false)}
        open={openFotoFinal}
        onSave={async fotos => {
          setOpenFotoFinal(false);
          handlerConfirm({
            fotos: await getFotos(fotos),
            codigo: '999',
            fotoInicio: false,
            fotoFim: true,
            analiseRisco: false,
            dataFotoDrone: moment().valueOf(),
          });
        }}
      />
      <DropzoneModal
        onClose={() => setOpenAnaliseRisco(false)}
        open={openAnaliseRisco}
        onSave={async fotos => {
          setOpenAnaliseRisco(false);
          handlerConfirm({
            fotos: await getFotos(fotos),
            codigo: '-001',
            fotoInicio: false,
            fotoFim: false,
            analiseRisco: true,
            dataFotoDrone: moment().valueOf(),
          });
        }}
      />
      <DialogDefault
        open={openClone}
        handlerCancel={() => { setOpenClone(false); setCloneId(null); }}
        handlerConfirm={() => {
          setOpenClone(true);
          cloneNsmp(cloneId, () => {
            setCloneId(null);
            setOpenClone(false);
          });
        }}
        title="Você tem que deseja clonar o serviço?"
        confirmMessage="Clonar"
      >
        <DialogContentText> Ao clonar o serviço, todas as informações e fotos serão duplicadas. O novo serviço terá um novo código. </DialogContentText>
      </DialogDefault>
      <DialogDefault
        open={openDeleteClone}
        handlerCancel={() => { setOpenDeleteClone(false); setCloneId(null); }}
        handlerConfirm={() => {
          setOpenDeleteClone(true);
          deleteCloneNsmp(cloneId, () => {
            setOpenDeleteClone(false);
            setCloneId(null);
          });
        }}
        title="Você tem que deseja remover o serviço?"
        confirmMessage="Remover"
      >
        <DialogContentText> A informação será removida e não poderá ser mais recuperado. </DialogContentText>
      </DialogDefault>
      <DialogDefault
        open={openFiltro}
        handlerCancel={() => { 
          setOpenFiltro(false); 
          setFilterApplied(Object.keys(filtroValues ?? {}).length > 0); 
        }}
        handlerConfirm={() => {
          filter();
          setOpenFiltro(false);
          setFilterApplied(true);
        }}
        title="Filtros"
        confirmMessage="Filtrar"
        headerAction={[
          {
            onClick: () => {
              setRows(nsmps);
              setFiltroValues({});
              setOpenFiltro(false);
              setFilterApplied(false);
            },
            title: "Limpar",
          },
        ]}
      >
        <DialogContentText> 
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Input
                name="numeroPoste"
                label="Identificador Poste"
                onChange={event => setFiltroValues({...filtroValues, [event.target.name]: event.target.value}) }
                value={filtroValues.numeroPoste}
              />
            </Grid>
            <Grid item xs={12}>
              <Input
                label="Endereço"
                name="endereco"
                onChange={event => setFiltroValues({...filtroValues, [event.target.name]: event.target.value}) }
                value={filtroValues.endereco}
              />
            </Grid>
            <Grid item xs={12}>
              <SearchSelect
                label="Situação do Poste"
                multiSelect
                onSelect={situacaoPostes => setFiltroValues({ ...filtroValues, situacaoPostes })}
                options={[
                  {'value': 'Com irregularidade', 'label': 'Com irregularidade'},
                  {'value': 'Sem irregularidade', 'label': 'Sem irregularidade'},
                  {'value': 'Não compartilhável', 'label': 'Não compartilhável'},
                  {'value': 'Não localizado', 'label': 'Não localizado'},
                  {'value': 'Vazio', 'label': 'Em branco'},
                ]}
                value={filtroValues.situacaoPostes}
              />
            </Grid>
            <Grid item xs={12}>
              <SearchSelect
                label="Status da Digitação"
                multiSelect
                onSelect={statusDigitacao => setFiltroValues({ ...filtroValues, statusDigitacao })}
                options={[
                  {'value': '1', 'label': 'Aguardando Digitação'},
                  {'value': '2', 'label': 'Digitação em andamento'},
                  {'value': '3', 'label': 'Digitação Finalizada'},
                ]}
                value={filtroValues.statusDigitacao}
              />
            </Grid>
          </Grid>
        </DialogContentText>
      </DialogDefault>
    </>
  );
};

const mapStateToProps = state => ({
  userRole: selectorsAuth.getRole(state),
  userId: selectorsAuth.getUserId(state),
  authData: selectorsAuth.getAuth(state)
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      ...actionsNsmp
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UsuMutuoServiceTab);
